import { createSlice } from "@reduxjs/toolkit";
export const initialClientCreationLocalState = {
  companyName: "",
  username: "",
  email: "",
  password: "",
  confirmPassword: "",
};

const initialState = {
  isSignupClientSuccess: false,
  newAdminLocal: initialClientCreationLocalState,
  isUniqueEmailError: false,
  isUniqueUserNameError: false,
  isOtpVerifyResponseSuccess: false,
  isResetOtpResponseSuccess: false,
  isSubscriptionResponse: false,
  isResendPaymentLikeResponse: false,
  isSubscriptionResponseData: null,
  nextActionUpdated:false,
};

export const adminCreationSlice = createSlice({
  name: "ClientCreation",
  initialState,
  reducers: {
    creationClientAction: (state, { payload }) => {},
    setCreationClientAction: (state, { payload }) => {
      state.isSignupClientSuccess = payload;
    },

    OtpVerifyAction: (state, { payload }) => {},
    setOtpVerifyAction: (state, { payload }) => {
      state.isOtpVerifyResponseSuccess = payload;
    },

    resendOtpAction: (state, { payload }) => {},
    setResendOtpAction: (state, { payload }) => {
      state.isResetOtpResponseSuccess = payload;
    },

    addSubscriptionAction: (state, { payload }) => {},
    setAddSubscriptionAction: (state, { payload }) => {
      state.isSubscriptionResponse = payload;
    },
    setSubscriptionResponseData: (state, { payload }) => {
      state.isSubscriptionResponseData = payload;
    },
    setNextActionUpdated(state, action) {
      state.nextActionUpdated = action.payload;
  },

    resendPaymentLikeAction: (state, { payload }) => {},
    setResendPaymentLikeAction: (state, { payload }) => {
      state.isResendPaymentLikeResponse = payload;
    },
  },
});

const {
  creationClientAction,
  setCreationClientAction,
  OtpVerifyAction,
  setOtpVerifyAction,
  resendOtpAction,
  setResendOtpAction,
  addSubscriptionAction,
  setAddSubscriptionAction,
  resendPaymentLikeAction,
  setResendPaymentLikeAction,setSubscriptionResponseData,setNextActionUpdated
} = adminCreationSlice.actions;
export {
  creationClientAction,
  setCreationClientAction,
  OtpVerifyAction,
  setOtpVerifyAction,
  resendOtpAction,
  setResendOtpAction,
  addSubscriptionAction,
  setAddSubscriptionAction,
  resendPaymentLikeAction,
  setResendPaymentLikeAction,setSubscriptionResponseData,setNextActionUpdated
};
export default adminCreationSlice.reducer;
